module.exports = __webpack_public_path__ + "media/swipe.bc228fc9.mp3";